import React,{useState,useEffect} from 'react'
import Grid from '@mui/material/Grid';
import { TextAreaInput1, TextInput } from '../../components/input';
import { ButtonFilled, ButtonOutlined } from '../../components/button';
import { useLocation, useNavigate } from 'react-router-dom';
import GoBack from '../../components/back/GoBack';
import Uploader from '../../components/Uploader';
import { FilterClientService, GetClientDetailService } from '../../services/ClientService';
import toast from 'react-hot-toast';
import { CreateCaseService, GetCaseDetailService, UpdateCaseService, UploadCaseFile } from '../../services/CaseService';
import CaseMenu from './CaseMenu';
import { Select } from 'antd';
import { FilterCaseTypeService, GetCaseTypeService } from '../../services/CaseTypeService';
import { GetCaseStageBasedTypeService } from '../../services/CaseStageService';
import { CreateActivityService } from '../../services/ActivityServices';
// import DailyTaskCE from './dailyTask/DailyTaskCE';

function CaseCE() {

 
  const [loader,setloader] = useState(false)  
  const [clientArr,setclientArr] = useState([])
  const [caseTypeArr,setcaseTypeArr] = useState([])
  const [caseStageArr,setcaseStageArr] = useState([])
  const {state,pathname} = useLocation()


  const path = pathname?.split('/')[pathname?.split('/').length -1]
  const path1 = pathname?.split('/')[pathname?.split('/').length -2]

  const status = [
    {label:'Pending',value:'Pending'},
    {label:'In Progress',value:'In Progress'},
    {label:'Completed',value:'Completed'},
    {label:'Hold',value:'Hold'},
  ]

  const [data,setdata] = useState({
    office_file_no:'',
    client:'',
    case_no:'',
    parties_name:'',
    advocate_for:'',
    court_hall:'',
    floor:'',
    stage:'',
    case_type:'',
  })

  const [error,seterror] = useState({
    office_file_no:'',
    client:'',
    case_no:'',
    parties_name:'',
    advocate_for:'',
    court_hall:'',
    stage:'',
    floor:'',
    stage:'',
    case_type:'',
  })


  const [activity,setactivity] = useState({attachment:'',remarks:'',next_hearing_date:''})
  const [activityerror,setactivityerror] = useState({attachment:'',remarks:'',next_hearing_date:''})

  const navigate = useNavigate()


  useEffect(()=>{
    if(path === 'edit'){
      geteditdata()
    }
    getCaseTypeAndStagefunc()
  },[])

  async function geteditdata(){
    const response =  await GetCaseDetailService(state?._id);
    let d = response?.data?.datas[0]
    if(d?._id !== undefined){

      let sendData = {...d}
      delete d.created_by

      if(d?.stage?._id !== undefined){
        sendData['stage'] = {label:d?.stage?.name,value:d?.stage?._id}
      }

      if(d?.case_type?._id !== undefined){
        sendData['case_type'] = {label:d?.case_type?.name,value:d?.case_type?._id}
      }

      if(d?.client?._id !== undefined){
        sendData['client'] = {label:d?.client?.name,value:d?.client?._id,data:d?.client}
      }

      if(d?.status !== undefined && d?.status !== null && d?.status !== ''){
        sendData['status'] = {label:d?.status,value:d?.status}
      }

      setdata({...sendData})
    }
  }

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name] : ''})
  }

  function handlechange1(e){
    setactivity({...activity,[e.target.name] : e.target.value})
    setactivityerror({...activityerror,[e.target.name] : ''})
  }

  async function submitform(){
    const sendData = {...data}

    if(data?.client?.value !== undefined){
      sendData['client'] = data?.client?.value
    }
    if(data?.case_type?.value !== undefined){
      sendData['case_type'] = data?.case_type?.value
    }
    if(data?.stage?.value !== undefined){
      sendData['stage'] = data?.stage?.value
    }
    if(data?.status?.value !== undefined){
      sendData['status'] = data?.status?.value
    }

    if(activity?.next_hearing_date !== ''){
      sendData['next_hearing_date'] = activity?.next_hearing_date
    }

    if(path !== 'edit'){
      const response = await CreateCaseService(sendData)
      if(response?.status === 201){
          toast.success("Case Detail Added Successfully!")
          resetform()
      }else{
          console.log("reponse?.data",response?.data)
      }
    }else{
      const response = await UpdateCaseService(sendData,state?._id)
      if(response?.status === 200){
          await createactivity()
          navigate(-1)
          toast.success("Case Detail Updated Successfully!")
          resetform()
      }else{
          console.log("reponse?.data",response?.data)
      }
    }
  }

  function resetform(){
     setdata({
        office_file_no:'',  
        client:'',
        case_no:'',
        parties_name:'',
        advocate_for:'',
        court_hall:'',
        stage:'',
        floor:'',
        stage:'',
        case_type:'',
      })
      seterror({
        office_file_no:'',
        client:'',
        case_no:'',
        parties_name:'',
        advocate_for:'',
        court_hall:'',
        stage:'',
        floor:'',
        stage:'',
        case_type:'',
      })
  }

  async function UploadFile(e,name){
    const response = await UploadCaseFile({file:e})
    setdata({...data,[name]:response?.data?.data})
  }

  async function UploadFile1(e,name){
    const response = await UploadCaseFile({file:e})
    setactivity({...activity,[name]:response?.data?.data})
  }

  async function getCaseTypeAndStagefunc(){
    const response = await GetCaseTypeService(1)
    let datas = response?.data?.datas

  
    let arr = []
    datas?.forEach((d)=>{
      arr.push({label:d?.name,value:d?._id})
    })
    setcaseTypeArr(arr)

    if(datas?.length > 0){
      if(path1 === 'civil_court'){
         let findData = datas?.find((f)=>f?.name === 'Civil Court')
         if(findData !== undefined && findData !== '' && findData !== null){
          setdata({...data,case_type:{label:findData?.name,value:findData?._id}})
          const response1 = await GetCaseStageBasedTypeService(findData?._id)
          let datas = response1?.data?.datas
          if(datas?.length > 0){
           let arr = []
           datas?.forEach((d)=>{
             arr.push({label:d?.name,value:d?._id})
           })
           setcaseStageArr(arr)
          }
         } 


      }

      if(path1 === 'high_court'){
        let findData = datas?.find((f)=>f?.name === 'High Court')
        if(findData !== undefined && findData !== '' && findData !== null){
         setdata({...data,case_type:{label:findData?.name,value:findData?._id}})
         const response1 = await GetCaseStageBasedTypeService(findData?._id)
          let datas = response1?.data?.datas
          if(datas?.length > 0){
           let arr = []
           datas?.forEach((d)=>{
             arr.push({label:d?.name,value:d?._id})
           })
           setcaseStageArr(arr)
          }
        } 
     }
    }
  }

  async function searchData(e,type){
    if(type == 'case_type'){
       const response = await FilterCaseTypeService(e,1)

       let datas = response?.data?.datas
       if(datas?.length > 0){
        let arr = []
        datas?.forEach((d)=>{
          arr.push({label:d?.name,value:d?._id})
        })
        setcaseTypeArr(arr)
       }

    }
    if(type == 'stage'){

      // const response = await FilterCaseStageService(e,1)
      // let datas = response?.data?.datas
      //  if(datas?.length > 0){
      //   let arr = []
      //   datas?.forEach((d)=>{
      //   arr.push({label:d?.name,value:d?._id})
      //   })
      //   setcaseStageArr(arr)
      // }
      
   }
   if(type == 'client'){
    const response = await FilterClientService(1,e,'','','active')
    let datas = response?.data?.datas
    if(datas?.length > 0){
      let arr = []
      datas?.forEach((d)=>{
      arr.push({label:d?.name,value:d?._id,data:d})
      })
      setclientArr(arr)
    }
   }
  }

  async function handleselect(e,type){
    if(type == 'case_type'){
     let dataFind = caseTypeArr.find((f)=>f?.value === e)
     const response1 = await GetCaseStageBasedTypeService(dataFind?.value)
       let datas = response1?.data?.datas
       if(datas?.length > 0){
          let arr = []
          datas?.forEach((d)=>{
          arr.push({label:d?.name,value:d?._id})
        })
        setcaseStageArr(arr)
      }
     setdata({...data,[type]:dataFind})
    }
    if(type == 'stage'){
      let dataFind = caseStageArr.find((f)=>f?.value === e)
      setdata({...data,[type]:dataFind})
    }
    if(type == 'client'){
      let dataFind = clientArr.find((f)=>f?.value === e)
      setdata({...data,[type]:dataFind})
    }
    if(type == 'status'){
      let dataFind = status.find((f)=>f?.value === e)
      setdata({...data,[type]:dataFind})
    }
  }


  async function createactivity(){
    const send_data = {
      case:data?._id, 
      // opinion_file:'', 
      client:data?.client?.value, 
      stage:data?.stage?.value, 
      attachment:activity?.attachment, 
      remarks:activity?.remarks, 
      next_hearing_date:'', 
      type:'case', 
    }

    if(activity?.next_hearing_date !== ''){
      send_data['next_hearing_date'] = activity?.next_hearing_date
    }

    const response = await CreateActivityService(send_data)
    if(response?.status === 201){
      toast.success("Activity Created Successfully")
    }
  }




  


  return (
    <div className='box-border pt-5 md:h-screen md:pt-0 md:max-h-screen md:overflow-hidden'>
    <div className='block sm:flex'>
        <CaseMenu />
    <div className='pr-5 ml-5 md:min-h-screen md:max-h-screen md:h-screen md:overflow-y-scroll' >
    

  

    <div className='md:w-[85%] md:min-w-[38vw] md:max-w-[38vw] mt-4 '>
      <GoBack />
     <div className='pb-2 border-b'>
      <h6 className='font-[800] mb-1'>{path === 'edit' ? 'Edit' : 'Create'} {path1 === 'civil_case' ? 'Civil Court' : 'High Court'} Case Info</h6> 
      <h6 className='text-[11px] leading-tight font-[500] p-2 bg-slate-100 '>Use the below form to create or edit the Case information for your client .</h6> 
     </div> 
     <div className='w-[100%] md:overflow-x-hidden'>

      {/* <h6 className='font-[800] text-[11px] bg-slate-100 p-[4px] mt-2'>Basic Info</h6>   */}
      <Grid container spacing={2}  >
        <Grid item xs={12}  md={6} >

      
        <h6 className='text-[11px] mt-2 font-[400] mb-1' >Client</h6>
        <Select 
          value={data.client}
          allowClear={true}
          showSearch={true}
          filterOption={false}
          onSearch={(e)=>searchData(e,'client')}
          onChange={e=>{handleselect(e,'client')}}
          options={clientArr}
          bordered={false}
          className='w-[100%] border border-slate-300'
        />

          <TextInput 
              mandatory={true}
              label={'Office File No'}  
              variant="standard"
              name="office_file_no"
              type="text"
              value={data.office_file_no}
              error={error.office_file_no}
              handlechange={handlechange}
              placeholder="Enter client name"
              InputLabelProps={{
                  style: { color: '#fff', }, 
              }}/>
              
               <TextInput 
              mandatory={true}
            label={'Case No'}  
            variant="standard"
            name="case_no"
            type="text"
            value={data.case_no}
            error={error.case_no}
            handlechange={handlechange}
            placeholder="Enter contact mobile"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>
             <TextAreaInput1 
            label={'Parties Name'}  
            variant="standard"
            name="parties_name"
            type="text"
            value={data.parties_name}
            error={error.parties_name}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>


<TextAreaInput1 
            label={'Advocate For'}  
            variant="standard"
            name="advocate_for"
            type="text"
            value={data.advocate_for}
            error={error.advocate_for}
            handlechange={handlechange}
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

           {path1 === 'civil_court' &&
            <>
            <TextInput 
              label={'Court Hall'}  
              variant="standard"
              name="court_hall"
              type="text"
              value={data.court_hall}
              error={error.court_hall}
              handlechange={handlechange}
              placeholder="Enter client secondary name"
              InputLabelProps={{
                  style: { color: '#fff', }, 
              }}/>
               <TextInput 
                label={'Floor Info'}  
                variant="standard"
                name="floor"
                type="text"
                value={data.floor}
                error={error.floor}
                handlechange={handlechange}
                placeholder="Enter secondary contact"
                InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>
          </>}
            
        </Grid>
        <Grid item xs={12} md={6} >
        
         

         <div className='mt-0' >
         
         <Uploader error={error?.file} name="file" required={true} label={'File'} image={data?.file}  setimagefunc={(e)=>{UploadFile(e,'file');seterror({...error,file:''})}}  removeimageuploadfunc = {()=>{setdata({...data,file:''});seterror({...error,file:''})}} />



              <TextAreaInput1 
            label={'Comments'}  
            variant="standard"
            name="comments"
            type="text"
            value={data.comments}
            error={error.comments}
            handlechange={handlechange}
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

       
        <h6 className='text-[11px] mt-2 font-[400] mb-1' >Case Type</h6>
        <Select 
          value={data.case_type}
          options={caseTypeArr}
          allowClear={true}
          bordered={false}
          showSearch={true}
          onSearch={(e)=>searchData(e,'case_type')}
          onChange={e=>{handleselect(e,'case_type')}}
          className='w-[100%] border border-slate-300'
        />

        <h6 className='text-[11px] mt-2 font-[400] mb-1' >Stage</h6>
        <Select 
          value={data.stage}
          // allowClear={true}
          // showSearch={true}
          // filterOption={false}
          // onSearch={(e)=>searchData(e,'stage')}
          onChange={e=>{handleselect(e,'stage')}}
          options={caseStageArr}
          bordered={false}
          className='w-[100%] border border-slate-300'
        />


<h6 className='text-[11px] mt-2 font-[400] mb-1' >Case Status</h6>
        <Select 
          value={data.status}
          // allowClear={true}
          // showSearch={true}
          // filterOption={false}
          // onSearch={(e)=>searchData(e,'stage')}
          onChange={e=>{handleselect(e,'status')}}
          options={status}
          bordered={false}
          className='w-[100%] border border-slate-300'
        />


       {/* Activity Update  */}

       {/* && data?.stage?.value !== state?.stage?._id */}
        {(state?._id !== undefined) &&
        <div>
          <Uploader error={activityerror?.attachment} name="attachment" required={false} label={'Attachment'} image={activity?.attachment}  setimagefunc={(e)=>{UploadFile1(e,'attachment');setactivityerror({...activityerror,attachment:''})}}  removeimageuploadfunc = {()=>{setactivity({...activity,attachment:''});setactivityerror({...activityerror,attachment:''})}} />
        
          <TextAreaInput1 
              label={'Remarks'}  
              variant="standard"
              name="remarks"
              type="text"
              value={activity.remarks}
              error={activityerror.remarks}
              handlechange={handlechange1}
              InputLabelProps={{
                  style: { color: '#fff', }, 
              }}/>

          <TextInput 
              mandatory={false}
              label={'Next Hearing Date'}  
              variant="standard"
              name="next_hearing_date"
              type="date"
              value={activity.next_hearing_date}
              error={activityerror.next_hearing_date}
              handlechange={handlechange1}
              placeholder="Enter contact mobile"
              InputLabelProps={{
                  style: { color: '#fff', }, 
              }}/>
        </div> }

        
        


         </div>

         


       

        
       
        </Grid>
      </Grid>

   
      </div>

   
   <div >
    <div className='flex items-center pt-5 mt-5 mb-10 border-t'>
        <div className='mr-2'>
        <ButtonOutlined btnName={'Back'} onClick={()=>navigate(-1)} />
        </div>
        <div>
        {loader ?   
        <ButtonFilled btnName={loader ? 'Loading' : 'Save'} /> :
        <ButtonFilled btnName={loader ? 'Loading' : 'Save'} onClick={()=>submitform(null)} /> }
        </div>
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>
   
  )
}

export default CaseCE